import Vue from 'vue'

function setHref (el, binding) {
  if (binding.oldValue === undefined || binding.value !== binding.oldValue) {
    const fileUrl = binding.value

    Vue.http.get(fileUrl, { responseType: 'arraybuffer' })
      .then(function (resp) {
        el.href = window.URL.createObjectURL(new Blob([new Uint8Array(Buffer.from(resp.body, 'binary'))]))
        el.click()
      })
      .catch(function (e) {
        el.href = fileUrl
        el.click()
      })
  }
}

const vueAuthFileDownload = {}

vueAuthFileDownload.install = function (Vue) {
  Vue.directive('auth-file-download', {
    bind: function (el, binding, vnode) {
      const onclick = event => {
        if (!el.href) {
          setHref(el, binding)
        }
      }
      el.addEventListener('click', onclick)
    },
    componentUpdated: function (el, binding, vnode) {
      const onclick = event => {
        if (!el.href) {
          setHref(el, binding)
        }
      }
      el.addEventListener('click', onclick)
    }
  })
}

export default vueAuthFileDownload
